import { memo } from "react";
import type { IconProps } from "types";



const Basket = ({ onClick, color = "#C76B6B", width = "15", height = "16", style, className }: IconProps) => {
  return (
    <svg
      cursor={"pointer"}
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{cursor: onClick ? "pointer" : "auto", ...style}}
      className={className}
    >
      <g clipPath="url(#clip0_282_5179)">
        <path d="M15 0.5H0V15.5H15V0.5Z" fill="white" fillOpacity="0.01" />
        <path
          d="M2.8125 3.625V14.25H12.1875V3.625H2.8125Z"
          stroke={color}
          strokeWidth="0.9375"
          strokeLinejoin="round"
        />
        <path
          d="M6.25006 6.75V10.8125"
          stroke={color}
          strokeWidth="0.9375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.74994 6.75V10.8125"
          stroke={color}
          strokeWidth="0.9375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.24994 3.625H13.7499"
          stroke={color}
          strokeWidth="0.9375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.99994 3.625L6.02775 1.75H8.99278L9.99994 3.625H4.99994Z"
          stroke={color}
          strokeWidth="0.9375"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_282_5179">
          <rect width="15" height="15" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(Basket);
